import request from '@/api/request';

export function getVehicles () {
  return request({
    url: '/vehicle',
    method: 'get'
  });
}

export function createVehicle (data) {
  return request({
    url: '/vehicle',
    method: 'post',
    data
  });
}

export function updateVehicle (data) {
  return request({
    url: '/vehicle',
    method: 'put',
    data
  });
}

export function deleteVehicle (vehicleId) {
  let data = {
    id: vehicleId
  };
  return request({
    url: '/vehicle/transfer',
    method: 'put',
    data
  });
}

export function getVehicleWaypoints (uctTicks) {
  return request({
    url: '/vehicle/laststates',
    method: 'get',
    params: {
      uctTicks
    }
  });
}

export function sendCommandToDeviceByEnum (data) {
  return request({
    url: '/vehicle/sendCommand',
    method: 'post',
    data
  });
}

export function rebootDevice (data) {
  return request({
    url: '/vehicle/reboot',
    method: 'post',
    data
  });
}

export function turnOffEngine (vehicleId) {
  let data = {
    vehicleId
  };
  return request({
    url: '/vehicle/turnoff',
    method: 'post',
    data
  });
}

export function restoreEngine (vehicleId) {
  let data = {
    vehicleId
  };
  return request({
    url: '/vehicle/turnon',
    method: 'post',
    data
  });
}

export function getTrackLogHistory (params) {
  return request({
    url: '/vehicle/historypoints',
    method: 'get',
    params
  });
}

export function getSecurityConfig (vehicleId) {
  return request({
    url: '/vehicle/securityconfig',
    method: 'get',
    params: {
      vehicleId
    }
  });
}

export function updateSecurityConfig (data) {
  return request({
    url: '/vehicle/securityconfig',
    method: 'put',
    data
  });
}

export function shareLocation (data) {
  return request({
    url: '/vehicle/sharing',
    method: 'post',
    data
  });
}

export function checkSharingCode (params) {
  return request({
    url: '/vehicle/sharing/checkcode',
    method: 'get',
    params
  });
}

export function getSharingStates (params) {
  return request({
    url: '/vehicle/sharing/laststates',
    method: 'get',
    params
  });
}

export function stopSharingLocation (data) {
  return request({
    url: '/vehicle/sharing/stop',
    method: 'put',
    data
  });
}

export function intervalSendData (data) {
  return request({
    url: '/vehicle/Interval',
    method: 'put',
    data
  });
}

export function updateCutOffEngine (data) {
  return request({
    url: '/vehicle/UpdateCutOffEngine',
    method: 'put',
    data
  });
}

export function updateLastWaypoint (data) {
  return request({
    url: '/vehicle/updatelastwaypoint',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/vehicle.js